import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useIsMobileBreakpoint } from '@/hooks/useIsBreakpoint';
import pinIcon from '@/pages/Schedule/icons/pin.png';
import { Button, Menu, MenuButton, MenuItem, MenuList } from '@/ui';
import { EntryModalField } from '../EntryModalField';
import { LocationInput } from './LocationInput';

type Props = {
  value: string;
  googlePlaceId: string | null | undefined;
  onChange: (location: string, placeId: string | null) => void;
};

// SIKE! this isn't actually a sheet. It used to be though and I didn't change it for consistency
export const LocationSheet = ({ value, googlePlaceId, onChange }: Props) => {
  const { t } = useTranslation('entryModal');
  const [isEditing, setIsEditing] = useState(false);
  const isMobileBreakpoint = useIsMobileBreakpoint();

  const showActionMenu =
    !!value && !!googlePlaceId && !isEditing && isMobileBreakpoint;

  return (
    <EntryModalField
      icon={<img alt="" height="18px" src={pinIcon} width="18px" />}
      placeholder={t('location.placeholder')}
    >
      {showActionMenu ? (
        <Menu>
          <MenuButton
            as={Button}
            justifyContent="start"
            textAlign="left"
            variant="notion"
            w="100%"
            whiteSpace="normal"
          >
            {value}
          </MenuButton>
          <MenuList>
            <MenuItem onClick={() => setIsEditing(true)}>
              {t('location.menu.edit')}
            </MenuItem>
            <MenuItem
              onClick={() => {
                window.open(
                  `https://maps.google.com/maps?q=${encodeURIComponent(value)}`,
                  '_blank'
                );
                setIsEditing(false);
              }}
            >
              {t('location.menu.open')}
            </MenuItem>
          </MenuList>
        </Menu>
      ) : (
        <LocationInput
          autoFocus={isEditing}
          value={value}
          onBlur={() => setIsEditing(false)}
          onChange={onChange}
        />
      )}
    </EntryModalField>
  );
};
